export const scElectric = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 20,
  inputPaddingInline: 15,

  inputHeight: 40,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 18,
  inputFontFamily: '"Montserrat", sans-serif',
  inputColor: "#000000",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 400,

  inputBorderColor: "#D4D4D7",
  inputBorderWidth: 1,
  inputBorderRadius: 6,

  inputHoverColor: "#000000",
  inputHoverBorderColor: "#D4D4D7",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 20,
  selectPaddingInline: 15,

  selectHeight: 40,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 18,
  selectFontFamily: '"Montserrat", sans-serif',
  selectColor: "#000000",
  selectBackgroundColor: "#F0F0F0",
  selectFontWeight: 400,

  selectBorderColor: "#D4D4D7",
  selectBorderWidth: 1,
  selectBorderRadius: 6,

  selectHoverColor: "#000000",
  selectHoverBorderColor: "#D4D4D7",
  selectHoverBackgroundColor: "#F0F0F0",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 20,
  textAreaPaddingInline: 15,

  textAreaHeight: 75,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 18,
  textAreaFontFamily: '"Montserrat", sans-serif',
  textAreaColor: "#000000",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 400,

  textAreaBorderColor: "#D4D4D7",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 6,

  textAreaHoverColor: "#000000",
  textAreaHoverBorderColor: "#D4D4D7",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#000000",
  placeholderFontFamily: '"Montserrat", sans-serif',
  placeholderFontSize: 18,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#000000",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 12,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 18,
  fieldLabelColor: "#000000",
  fieldLabelFontWeight: 400,
  fieldLabelColorAsterisk: "#000000",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Montserrat", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#000000",
  descriptionFontSize: 18,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Montserrat", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 18,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 6,
  checkboxUncheckedBorderColor: "#D4D4D7",
  checkboxUncheckedBackgroundColor: "#FFFFFF",
  checkboxCheckedBackgroundColor: "#007A53",
  checkboxCheckedBorderColor: "#D4D4D7",
  checkboxCheckedColor: "#FFFFFF",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Montserrat", sans-serif',
  checkboxLabelFontSize: 18,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#000000",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 18,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#D4D4D7",
  radioUncheckedBackgroundColor: "#ffffff",
  radioCheckedBackgroundColor: "#007A53",
  radioCheckedBorderColor: "#D4D4D7",

  radioAlignment: "none",

  radioLabelFontFamily: '"Montserrat", sans-serif',
  radioLabelFontSize: 18,
  radioLabelFontWeight: 400,
  radioLabelColor: "#000000",

  // **********************************
  // submit button

  submitMarginTop: 60,
  submitFontSize: 18,
  submitFontFamily: "'Montserrat', sans-serif",
  submitWidth: 172,
  submitWidthUnits: "px",
  submitHeight: 47,
  submitBorderRadius: 0,
  submitBorderWidth: 1,
  submitBackground: "#007A53",
  submitColor: "#FFFFFF",
  submitBorderColor: "#007A53",
  submitBackgroundHover: "#007A53",
  submitBorderColorHover: "#007A53",
  submitColorHover: "#FFFFFF",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 700,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "center",
};

  